<!--
 * @Descripttion: 确认密码
 * @FilePath: /mall-wap-vue/src/views/login/forgot/reset/components/ConfirmPasswordField/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-10 16:13:08
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-22 21:51:26
-->
<template>
  <div class="passwd">
    <van-field
      v-model="password"
      name="newPassword"
      placeholder="请输入密码"
      label="确认密码"
      label-width="52px"
      :class="password ? 'password_field' : 'password_field_un'"
      :type="showEye ? 'text' : 'password'"
      clearable
      @input="passwordChange"
    >
      <template #button>
        <img
          v-if="showEye"
          src="@/assets/login/eye_open.png"
          alt=""
          class="eye"
          @click.stop="closeEye"
        />
        <img
          v-if="!showEye"
          src="@/assets/login/eye_close.png"
          alt=""
          class="eye"
          @click.stop="openEye"
        />
      </template>
    </van-field>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      password: this.value,
      showEye: false
    };
  },
  methods: {
    passwordChange(value) {
      this.$emit("input", value);
    },
    openEye() {
      this.showEye = true;
    },
    closeEye() {
      this.showEye = false;
    }
  }
};
</script>

<style lang="less" scoped>
.passwd {
  padding: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  .password_field {
    font-size: 16px;
    font-weight: 600;
    padding: 10px 0;
  }

  .password_field_un {
    font-size: 12px;
    font-weight: 400;
    padding: 10px 0;
  }

  ::v-deep .van-field__label {
    color: black;
    font-weight: 600;
    font-size: 12px;
  }

  .eye {
    width: 17px;
    height: 17px;
    display: block;
  }
}
</style>
